import type { CalculatedRange, Range, StatsType } from '@/types/stats.types'

export function calculateRanges(
  stats: StatsType,
  ranges: Range[],
): CalculatedRange {
  const result: CalculatedRange = {}

  for (const range of ranges) {
    result[range.label] = 0
  }

  for (const [key, value] of Object.entries(stats)) {
    const statKey = parseFloat(key)

    if (Number.isNaN(statKey)) {
      // eslint-disable-next-line no-continue
      continue
    }

    const range = ranges.find(r => statKey >= r.min && statKey <= r.max)

    if (range) {
      result[range.label] += value
    }
  }

  return result
}
